// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

class Filters extends React.Component<any> {
  static type = 'filtersComponent';

  static propTypes = {
    render: PropTypes.func,
    setFilterKey: PropTypes.func,
    setFilter: PropTypes.func,
    children: PropTypes.any,
    filter: PropTypes.object,
  };

  static defaultProps = {
    render: undefined,
    setFilterKey: noop,
    setFilter: noop,
    children: undefined,
    filter: {},
  };

  render() {
    const { render, filter, children } = this.props;

    if (render) {
      return render.call(this);
    }

    const context = {
      apply: this.props.setFilterKey,
      reset: this.props.setFilter,
      filter,
    };

    return children(context);
  }
}

export default Filters;
